import { AnchorProps } from '@/components/base/anchor'
import { ImageProps } from '@/components/base/image'
import { PointProps } from '@/components/widgets/plan-your-trip/types'

export interface IMichelineMapItemLozenge {
  id: string
  text: string
}

export interface IMichelineMapItem {
  title: string
  description: string
  address: string
  isSustainability: boolean
  lozenge: IMichelineMapItemLozenge
  lat: string
  lng: string
  src: ImageProps
  mapLink: AnchorProps
  anchor: AnchorProps
}

export enum IAuthUrl {
  LOGIN = 'login',
  LOGOUT = 'logout',
  LOGOUTREDIRECTLOGIN = 'logoutredirectlogin',
  REDIRECT = 'redirect',
  SIGN_IN = 'sign-in',
  REGISTER = 'register',
}

export type OptionType = {
  rawData: any
  value: string
  label: string
}

export interface IHistoryData {
  selectedOrigin?: OptionType | null
  selectedDestination?: OptionType | null
  selectedRoutePoints?: Array<PointProps> | null
}

export type ICallback = (...args: any[]) => void
export type IRedirectQueries = Array<{ key: string; value: string }>

export enum CookieName {
  Advertising = 'GT_Advertising',
  AllowedSettings = 'GT_AllowedSettings',
  Lang = 'lang',
  Performance = 'GT_Performance',
  Session = 'GT_CookieSession',
  Time = 'GT_Time',
  Tracking = 'GT_Tracking',
  UserId = 'GT_UserId',
  TrackingCode = 'trackingCode',
  Theme = 'theme',
  Token = 'token',
  RefreshToken = 'refreshToken',
  UserInfo = 'userInfo',
}

export interface CookieTracking {
  userId: string
  pageId: string
  referrer: string
  fp: string
  pageInitializedAt?: string
}

export interface CookieTime {
  time: string
  offset: number
}

export interface CookieSession {
  sessionId: string
  sessionStartAt: string
}

export interface IGetCity {
  total?: number
  pageCount?: number
  cities: [
    {
      id: string
      name: string
      language?: number
      countryId: string
    },
  ]
}

export interface IGetCountry {
  total?: number
  pageCount?: number
  countries: [
    {
      id: string
      name: string
      language?: number
    },
  ]
}

export interface IUserData {
  sub?: string
  given_name?: string
  family_name?: string
  name?: string
  username?: string
  language?: string
  email?: string
  email_verified?: boolean
  gender?: number
  allowCommunication?: boolean
  allowNewsletter?: boolean
  allowWhatsAppCommunication?: boolean
  birthDate?: string
  city?: string
  cityId?: string
  country?: string
  countryId?: string
  phoneNumber?: string
  middlename?: string
  isNomandUser?: boolean
}

export interface IUserUpdate {
  FirstName?: string
  LastName?: string
  Middlename?: string
  Email?: string
  PhoneNumber?: string
  Gender?: number
  BirthDate?: string
  CountryId?: string
  CityId?: string
  AllowWhatsAppCommunication?: boolean
  AllowCommunication?: boolean
  AllowNewsletter?: boolean
}
